import {
  getDepositTicketBalance,
  getDepositTicketOpenBets,
  getDepositTicketGradedBets,
  getDepositScanBarcode,
} from '@/utils/api';
import { getField, updateField } from 'vuex-map-fields';
import { LoginTypes, ExternalWagerLoginTypes } from '@/utils/enums';
import { formatOpenBetsData } from '@/views/history/history-utils';
import { _api } from '@/utils/apiAxios';
import { calcStore, persistCalc } from '@/utils/calculator';
import { extractError } from '@/utils/errorUtil';

const PREF_SCAN_CODE = 'PREF_SCAN_CODE';

const getDefaultState = () => {
  return {
    scanCode: localStorage.getItem(PREF_SCAN_CODE) || '',
    invalidScanCode: false,
    scanErrorMessage: '',
    scanStatus: {
      loading: false,
      success: false,
      error: false,
    },
    balanceStatus: {
      loading: false,
      success: false,
      error: false,
    },
    balanceResponse: {
      amount_at_risk: '0',
      available_balance: '0',
      current_balance: '0',
      settled_amount: '0',
      receipts: '',
      ticket_number: '',
    },
    state: 'IN_PENDING', // IN_PENDING | IN_WAGER | IN_BALANCE
    ticketOpenBets: [],
    ticketOpenBetsStatus: {
      loading: false,
      success: false,
      error: false,
    },
    ticketGradedBets: [],
    ticketGradedBetsStatus: {
      loading: false,
      success: false,
      error: false,
    },
    status: {
      loading: false,
    },
    isDefaultDepositFlow: true,
    betsConfirmationModal: false,
    sportsBookPayoutSuccessModal: false,
    isCalculatorOpened: false,
    calculations: calcStore(),
    isLoadingLoadWallet: false,
    scanDetailsData: null,
    modalOpenBets: [],
    modalGradedBets: [],
  };
};

const state = getDefaultState();

const getters = {
  getField,
  totalCalc: state => {
    return state.calculations.reduce((acc, curr) => acc + parseFloat(curr.amount), 0);
  },
};

const mutations = {
  updateField,
  setScanStatus(state, row) {
    state.scanStatus = {
      ...state.scanStatus,
      ...row,
    };
  },
  setScanCode(state, scanCode) {
    console.log('scanCode', scanCode);
    state.scanCode = scanCode;
    localStorage.setItem(PREF_SCAN_CODE, scanCode);
  },
  setBalanceStatus(state, row) {
    state.balanceStatus = {
      ...state.balanceStatus,
      ...row,
    };
  },
  setBalanceResponse(state, response) {
    state.balanceResponse = response;
    state.isDefaultDepositFlow = response.scan_type && response.scan_type !== 'D';
  },
  setTicketOpenBets(state, response) {
    state.ticketOpenBets = response;
  },
  setTicketOpenBetsStatus(state, row) {
    state.ticketOpenBetsStatus = {
      ...state.ticketOpenBetsStatus,
      ...row,
    };
  },
  setState(state, value) {
    state.state = value;
  },
  resetState(state) {
    Object.assign(state, getDefaultState());
    localStorage.removeItem(PREF_SCAN_CODE);
  },
  setTicketGradedBets(state, response) {
    state.ticketGradedBets = response;
  },
  setTicketGradedBetsStatus(state, row) {
    state.ticketGradedBetsStatus = {
      ...state.ticketGradedBetsStatus,
      ...row,
    };
  },
  setInvalidScanCode(state, row) {
    state.invalidScanCode = row;
  },
  setScanErrorMessage(state, row) {
    state.scanErrorMessage = row;
  },
  requestStart(state) {
    state.status = { loading: true };
  },
  requestEnd(state) {
    state.status = { loading: false };
  },
  setIsDefaultDepositFlow: (state, data) => {
    state.isDefaultDepositFlow = data;
  },
  setBetsConfirmationModal: (state, data) => {
    state.betsConfirmationModal = data;
  },
  setSportsBookPayoutSuccessModal: (state, data) => {
    state.sportsBookPayoutSuccessrModal = data;
  },
  addCalc: (state, { type, amount, ticketNumber, minus }) => {
    state.calculations = [...state.calculations, { type, amount, ticketNumber, minus, time: new Date() }];
    persistCalc(state.calculations);
  },
  clearCalc: state => {
    state.calculations = [];
    persistCalc([]);
  },
  setIsLoadingLoadWallet: (state, val) => {
    state.isLoadingLoadWallet = val;
  },
  setScanDetailsData: (state, val) => {
    state.scanDetailsData = val;
    state.modalOpenBets = val.data.ticket_detail.bets.filter(bet => !bet.wager_header.is_graded);
    state.modalGradedBets = val.data.ticket_detail.bets.filter(bet => bet.wager_header.is_graded);
  },
};

const actions = {
  async tryScanBarcode({ commit, rootState, rootGetters, dispatch, state }, scanCodeParam) {
    const canClerkLogin = rootState.settings.terminalInfo.can_clerk_login;

    console.log({ canClerkLogin });
    if (canClerkLogin == '1') {
      // if is clerk dont load wallet
      console.log('----if is clerk dont load wallet---');
      return;
    }

    if (!scanCodeParam) {
      return;
    }

    if (state.isLoadingLoadWallet) {
      console.log('isLoadingLoadWallet', state.isLoadingLoadWallet);
      return;
    }

    commit('setIsLoadingLoadWallet', true);

    let isSportsbook = false;
    let scaneCodeSelf = '';

    if (typeof scanCodeParam == 'string') {
      scaneCodeSelf = scanCodeParam;
    } else {
      scaneCodeSelf = scanCodeParam.scan_code;
    }

    if (typeof scanCodeParam == 'string') {
      commit('setScanCode', scanCodeParam);
    } else {
      commit('setScanCode', scanCodeParam.scan_code);
      isSportsbook = true;
    }
    const scanCode = (scaneCodeSelf && scaneCodeSelf.trim()) || state.scanCode.trim();
    const firstChar = scanCode.substring(0, 1);
    if (firstChar !== 'B' && firstChar !== 'D' && firstChar !== 'W') {
      commit('setInvalidScanCode', true);
      return;
    }
    commit('setInvalidScanCode', false);
    commit('requestStart');
    commit('clerkWagerStore/setTicketOpenBets', [], { root: true });
    commit('clerkWagerStore/setTicketGradedBets', [], { root: true });

    if (scanCode) {
      let customPayload = {};
      if (isSportsbook) {
        customPayload = { ...scanCodeParam };
      }
      const r = await _api.post('/terminal/loadwallet', {
        scan_code: scanCode,
        mac_address: rootState.settings.macAddress,
        loginType: rootState.player.loginType,
        ...customPayload,
      });
      commit('setIsLoadingLoadWallet', false);

      if (r.data.IsSuccess) {
        commit('setScanCode', r.data.Data.data.scan_code);
        if (firstChar === 'D') {
          commit('setBalanceResponse', r.data.Data.data);
          commit('setBalanceStatus', { success: true, error: false });

          // if login type is guest or DepositTicket switch to DepositTicket auth
          if (
            rootState.player.loginType === LoginTypes.Guest ||
            rootState.player.loginType === ExternalWagerLoginTypes.DepositTicket
          ) {
            commit('player/setLoginType', ExternalWagerLoginTypes.DepositTicket, { root: true });
          }

          // if login type is clerk, switch to ClerkDepositTicket
          if (rootState.player.loginType === LoginTypes.Clerk) {
            commit('player/setLoginType', ExternalWagerLoginTypes.ClerkDepositTicket, { root: true });
          }
        } else if (firstChar === 'B') {
          commit('clerkPayoutDepositTicketStore/setScanCode', scanCode, {
            root: true,
          });
          commit(
            'clerkPayoutDepositTicketStore/setTicketAllBets',
            {
              bets: r.data.Data.data.bets,
              horse_bets: r.data.Data.data.horse_bets,
            },
            { root: true },
          );

          const betData = r.data.Data.data;
          const isEmpty = (field, isObject = false) =>
            isObject ? !Object.keys(betData[field]).length : !betData[field];

          if (Object.keys(betData.bets || []).length > 0) {
            getDepositTicketOpenBets({
              scan_code: scanCode,
            }).then(r => {
              console.log(r.data);
              if (r.data.IsSuccess) {
                commit('setScanDetailsData', r.data.Data);
              } else {
                commit('setScanDetailsData', null);
              }
            });
          }

          if (
            isEmpty('ticket_number') &&
            isEmpty('ticket_description') &&
            isEmpty('service_description') &&
            isEmpty('sold_date') &&
            isEmpty('sold_value') &&
            isEmpty('clerk_user') &&
            isEmpty('clerk_id') &&
            isEmpty('description') &&
            isEmpty('currency') &&
            isEmpty('exchange_rate') &&
            isEmpty('scan_code') &&
            isEmpty('status') &&
            isEmpty('receipts') &&
            isEmpty('amount_at_risk') &&
            isEmpty('settled_amount') &&
            isEmpty('current_balance') &&
            isEmpty('scan_type') &&
            isEmpty('bets', true) &&
            isEmpty('horse_bets', true)
          ) {
            if (scanCode.startsWith('B')) {
              dispatch('clerkWagerStore/tryScanWagerBarcode', scanCode, { root: true });
              commit('clerkPayoutDepositTicketStore/setOpenWagerStatusModal', true, { root: true });
            }
          } else {
            commit('setBetsConfirmationModal', true);
          }
        } else if (firstChar === 'W') {
          commit('setBalanceResponse', r.data.Data.data);
          commit('setBalanceStatus', { success: true, error: false });

          // if login type is guest or DepositTicket switch to DepositTicket auth
          if (
            rootState.player.loginType === LoginTypes.Guest ||
            rootState.player.loginType === ExternalWagerLoginTypes.DepositTicket
          ) {
            commit('player/setLoginType', ExternalWagerLoginTypes.DepositTicket, { root: true });
          }

          // if login type is clerk, switch to ClerkDepositTicket
          if (rootState.player.loginType === LoginTypes.Clerk) {
            commit('player/setLoginType', ExternalWagerLoginTypes.ClerkDepositTicket, { root: true });
          }
        }

        commit('settings/setShowScanBarcodeModal', false, { root: true });
      } else {
        const error = extractError(r);
        if (error === 'TERMINAL.SCAN.NO_BALANCE_AVAILABLE') {
          commit('setScanErrorMessage', 'TERMINAL.SCAN.NO_BALANCE_AVAILABLE');
          commit('setInvalidScanCode', false);
        } else if(error === 'TERMINAL_SCAN_ALREADY_LOADED ') {
          commit('setScanErrorMessage', 'TERMINAL_SCAN_ALREADY_LOADED ');
          commit('setInvalidScanCode', false);
        } else if (error) {
          commit('setInvalidScanCode', false);
          commit('setScanErrorMessage', error);
        } else {
          commit('setInvalidScanCode', true);
          commit('setScanErrorMessage', '');
        }
      }

      return r;

      //commit("requestEnd");
    }
  },

  tryScanDepositTicket({ commit, dispatch, state, rootState }, data) {
    const notLogout = data && data.notLogout;
    const dontClearDeposit = data && data.dontClearDeposit;

    if (state.isDefaultDepositFlow) {
      commit('setBalanceStatus', {
        loading: true,
        success: false,
        error: false,
      });
      getDepositTicketBalance({
        scan_code: state.scanCode.trim(),
        mac_address: rootState.settings.macAddress,
      })
        .then(r => {
          if (r.data.IsSuccess) {
            const innerResponse = r.data.Data;
            const failed = innerResponse.status !== 'ok';
            if (!failed) {
              const data = innerResponse.data;
              if (data && data.length > 0) {
                const balanceResponse = data[0];
                if (balanceResponse.ticket_number) {
                  commit('setBalanceResponse', balanceResponse);
                  commit('setBalanceStatus', { success: true, error: false });

                  // if login type is guest or DepositTicket switch to DepositTicket auth
                  if (
                    rootState.player.loginType === LoginTypes.Guest ||
                    rootState.player.loginType === ExternalWagerLoginTypes.DepositTicket
                  ) {
                    commit('player/setLoginType', ExternalWagerLoginTypes.DepositTicket, { root: true });
                  }

                  // if login type is clerk, switch to ClerkDepositTicket
                  if (rootState.player.loginType === LoginTypes.Clerk) {
                    commit('player/setLoginType', ExternalWagerLoginTypes.ClerkDepositTicket, { root: true });
                  }
                } else {
                  commit('setBalanceStatus', { success: false, error: true });
                }
              }
            } else {
              commit('setBalanceStatus', { success: false, error: true });
            }
          } else {
            commit('setBalanceStatus', { success: false, error: true });
            commit('setState', 'IN_PENDING');
            commit('setInvalidScanCode', true);
          }
          commit('setBalanceStatus', { loading: false });
        })
        .finally(() => {
          commit('requestEnd');
        });
    } else {
      _api
        .post('/terminal/getactivebalance', {
          mac_address: rootState.settings.macAddress,
        })
        .then(r => {
          if (r.data.IsSuccess) {
            const res = r.data.Data.data;
            if (res && parseFloat(res.available_balance) > 0) {
              commit('setBalanceResponse', res);
            } else {
              if (!notLogout || rootState.settings.terminalInfo.printer.printer_model !== 'default') {
                if (rootState.player.loginType === ExternalWagerLoginTypes.DepositTicket) {
                  if (!dontClearDeposit) {
                    dispatch('player/clearDeposit', false, { root: true });
                  }
                }

                if (rootState.player.loginType === ExternalWagerLoginTypes.ClerkDepositTicket) {
                  dispatch('player/clearDeposit', true, { root: true });
                  commit('player/setLoginType', LoginTypes.Clerk, {
                    root: true,
                  });
                  commit('depositTicketStore/resetState', null, { root: true });
                }
              }
            }
          }
        });
    }
  },
  tryGetDepositTicketOpenBets({ commit, state, rootGetters }) {
    const scanCode = state.scanCode.trim();
    if (!scanCode) return;
    commit('setTicketOpenBetsStatus', { loading: true });
    getDepositTicketOpenBets({
      scan_code: scanCode,
    })
      .then(r => {
        if (r.data.IsSuccess) {
          const data = r.data.Data;
          const currencySymbol = rootGetters['player/currencySymbol'];
          commit('setTicketOpenBets', data.data.ticket_detail.bets.filter(bet => !bet.wager_header.is_graded));
          commit('setTicketGradedBets', data.data.ticket_detail.bets.filter(bet => bet.wager_header.is_graded));
          commit('setTicketOpenBetsStatus', {
            loading: false,
            success: true,
            error: false,
          });
        } else {
          commit('setState', 'IN_PENDING');
          commit('setInvalidScanCode', true);
          commit('setScanDetailsData', data);
          commit('setTicketOpenBetsStatus', {
            loading: false,
            success: false,
            error: true,
          });
        }
      })
      .finally(() => {
        commit('requestEnd');
      });
  },
  tryGetDepositTicketGradedBets({ commit, state, rootGetters }) {
    return;
    const scanCode = state.scanCode.trim();
    if (!scanCode) return;
    commit('setTicketGradedBetsStatus', { loading: true });
    getDepositTicketGradedBets({
      scan_code: scanCode,
    })
      .then(r => {
        if (r.data.IsSuccess) {
          const currencySymbol = rootGetters['player/currencySymbol'];
          commit('setTicketGradedBets', formatOpenBetsData(r.data.Data.data, currencySymbol));
          commit('setTicketGradedBetsStatus', {
            loading: false,
            success: true,
            error: false,
          });
        } else {
          commit('setState', 'IN_PENDING');
          commit('setInvalidScanCode', true);
          commit('setTicketGradedBetsStatus', {
            loading: false,
            success: false,
            error: true,
          });
        }
      })
      .finally(() => {
        commit('requestEnd');
      });
  },
  cancelScanCode({ commit, state, dispatch }) {
    dispatch('player/logout', null, { root: true });
    commit('resetState');
  },
};

export const depositTicketStore = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
